"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
function usePaints({ drawable, color, opacity, size, offset, curves, setCurves, onPaintEnd, isGlobalPen = true, }) {
    const [isDrawing, setDrawing] = (0, react_1.useState)(false);
    const OFFSET_X = 0;
    const OFFSET_Y = 0;
    const onPaintStartHandler = (0, react_1.useCallback)((event) => {
        if (!drawable || (0, ui_1.isMultiTouchEvent)(event)) {
            return;
        }
        const point = (0, ui_1.getPosition)(event);
        const adjustedPoint = {
            x: point.x - OFFSET_X,
            y: point.y - OFFSET_Y,
        };
        const coords = (0, ui_1.getDelta)(adjustedPoint, offset);
        const curve = {
            color: `rgba(${color},${opacity})`,
            size: size,
            points: [
                {
                    x: isGlobalPen ? coords.x / window.innerWidth : coords.x,
                    y: isGlobalPen ? coords.y / window.innerHeight : coords.y,
                },
            ],
        };
        setCurves([...(curves || []), curve]);
        setDrawing(true);
    }, [drawable, offset, color, opacity, size, isGlobalPen, setCurves, curves]);
    const onPaintHandler = (0, react_1.useCallback)((event) => {
        var _a;
        if (isDrawing && !(0, ui_1.isMultiTouchEvent)(event)) {
            const point = (0, ui_1.getPosition)(event);
            const adjustedPoint = {
                x: point.x - OFFSET_X,
                y: point.y - OFFSET_Y,
            };
            if (curves) {
                const index = curves.length - 1;
                const copyCurves = [...curves];
                const coords = (0, ui_1.getDelta)(adjustedPoint, offset);
                (_a = copyCurves[index]) === null || _a === void 0 ? void 0 : _a.points.push({
                    x: isGlobalPen ? coords.x / window.innerWidth : coords.x,
                    y: isGlobalPen ? coords.y / window.innerHeight : coords.y,
                });
                setCurves(copyCurves);
            }
        }
    }, [curves, isDrawing, isGlobalPen, offset, setCurves]);
    const onPaintEndHandler = (0, react_1.useCallback)(() => {
        if (isDrawing) {
            setDrawing(false);
            onPaintEnd(curves);
        }
    }, [curves, isDrawing, onPaintEnd]);
    return [onPaintStartHandler, onPaintHandler, onPaintEndHandler];
}
exports.default = usePaints;
